<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <hr>

    <!-- ── DataTable ──────────────────────────────────────────── -->
    <DataTable
      :data="planilladets"
      :columns="columnas"
      idField="idPlanillaDet"
      :acciones="true"
      :mostrarBotonTodos="true"
      :mostrarBotonNuevo="true"
      :mostrarBotonExcel="false"
      :mostrarInfo="false"
      :mostrarEditar="true"
      :mostrarVer="false"
      :mostrarEliminar="true"
      mensajeVacio="No hay registros disponibles."
      @refresh="cargarDatos()"
      @create="abrirModalCrear()"
      @edit="({ idPlanillaDet }) => abrirModalEditar(idPlanillaDet)"
      @delete="({ idPlanillaDet }) => deletePlanillaDet(idPlanillaDet)"
    >
      <!-- Fecha formateada -->
      <template #cell-fechaAtencion="{ row }">
        {{ getFormattedDate(row.fechaAtencion) }}
      </template>

      <!-- Valor total calculado -->
      <template #cell-valorTotal="{ row }">
        {{ formatearPrecio(row.valorTotal) }}
      </template>
    </DataTable>

    <!-- ── Modal crear / editar ───────────────────────────────── -->
    <div class="modal fade" id="ventanaModal" tabindex="-1"
         aria-labelledby="modalPlanillaDetLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white" id="modalPlanillaDetLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white"
                    data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form @submit.prevent>
            <div class="modal-body">

              <!-- Feedback -->
              <div class="container-fluid mt-3 feedback-container" aria-live="polite">
                <transition name="feedback-slide">
                  <div v-if="mensajeFeedback.texto"
                       class="alert alert-dismissible fade show shadow-sm"
                       :class="{
                         'alert-success': mensajeFeedback.tipo === 'success',
                         'alert-danger':  mensajeFeedback.tipo === 'error',
                         'alert-warning': mensajeFeedback.tipo === 'warning',
                         'alert-info':    mensajeFeedback.tipo === 'info',
                       }" role="alert">
                    <div class="d-flex align-items-center">
                      <i class="material-icons me-3" style="font-size:28px">
                        {{ getFeedbackIcon(mensajeFeedback.tipo) }}
                      </i>
                      <div class="flex-grow-1">
                        <strong>{{ mensajeFeedback.texto }}</strong>
                        <div v-if="mensajeFeedback.detalle" class="small text-muted mt-1">
                          {{ mensajeFeedback.detalle }}
                        </div>
                      </div>
                      <button type="button" class="btn-close"
                              @click="ocultarMensajeFeedback()"
                              aria-label="Cerrar mensaje"></button>
                    </div>
                  </div>
                </transition>
              </div>

              <!-- LOV Elemento -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">{{ labelElemento }}</label>
                  </div>
                  <div class="col-10 position-relative">
                    <div class="input-group">
                      <span class="input-group-text">
                        <i class="material-icons" style="font-size:20px">search</i>
                      </span>
                      <input type="text" class="form-control"
                             v-model="searchElemento"
                             @input="buscarElementos()"
                             @focus="mostrarListaElementos = true"
                             @blur="ocultarListaDelay()"
                             :placeholder="`Escriba código o nombre ${placeholderElemento} (mín. 2 caracteres)...`"
                             autocomplete="off" required>
                      <button v-if="searchElemento" type="button"
                              class="btn btn-outline-secondary"
                              @click="limpiarBusqueda()">
                        <i class="material-icons" style="font-size:18px">clear</i>
                      </button>
                    </div>

                    <div v-if="cargandoElementos && searchElemento.length >= 2" class="text-center mt-2">
                      <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
                      <small class="text-muted ms-2">Buscando elementos...</small>
                    </div>

                    <div v-if="datoPlanillaDet.idElemento && !mostrarListaElementos"
                         class="elemento-seleccionado mt-2 p-3 border rounded bg-light">
                      <div class="row">
                        <div class="col-md-3">
                          <small class="text-muted d-block">Código:</small>
                          <strong class="text-primary">{{ datoPlanillaDet.elementoCodigo }}</strong>
                        </div>
                        <div class="col-md-6">
                          <small class="text-muted d-block">Descripción:</small>
                          <strong>{{ datoPlanillaDet.elementoNombre }}</strong>
                        </div>
                        <div class="col-md-3">
                          <small class="text-muted d-block">Tarifa:</small>
                          <strong class="text-success">${{ formatearPrecio(elementoSeleccionadoCompleto?.valor) }}</strong>
                          <small class="d-block text-muted">{{ elementoSeleccionadoCompleto?.tarifaConvNombre }}</small>
                        </div>
                      </div>
                    </div>

                    <div v-if="mostrarListaElementos && elementosFiltrados.length > 0"
                         class="list-group position-absolute w-100 mt-1 shadow-lg"
                         style="max-height:400px;overflow-y:auto;z-index:1050;border-radius:8px">
                      <div class="list-group-item bg-primary text-white py-2">
                        <small><strong>{{ elementosFiltrados.length }}</strong> resultado(s)</small>
                      </div>
                      <button type="button"
                              class="list-group-item list-group-item-action elemento-item"
                              v-for="elem in elementosFiltrados" :key="elem.idTarifaPres"
                              @mousedown.prevent="seleccionarElemento(elem)">
                        <div class="d-flex justify-content-between align-items-start">
                          <div class="flex-grow-1">
                            <div class="d-flex align-items-center mb-1">
                              <span class="badge bg-primary me-2">{{ elem.elementoCodigo }}</span>
                              <span class="badge bg-info text-dark">{{ elem.tarifaConvNombre }}</span>
                            </div>
                            <div class="elemento-nombre">{{ elem.elementoNombre }}</div>
                          </div>
                          <div class="text-end ms-3">
                            <div class="precio-elemento">${{ formatearPrecio(elem.valor) }}</div>
                            <small class="text-muted d-block">ID: {{ elem.idElemento }}</small>
                          </div>
                        </div>
                      </button>
                    </div>

                    <div v-if="mostrarListaElementos && elementosFiltrados.length === 0 && searchElemento.length >= 2 && !cargandoElementos"
                         class="alert alert-warning mt-2">
                      No se encontraron elementos para "<strong>{{ searchElemento }}</strong>"
                    </div>
                  </div>
                </div>
              </div>

              <!-- Cantidad y Valor Unitario -->
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-3"><label class="form-label">Cantidad</label></div>
                  <div class="col-3">
                    <input type="number" class="form-control"
                           v-model="datoPlanillaDet.cantidad"
                           @input="calcularTotal()" min="1" step="1" required>
                  </div>
                  <div class="col-3"><label class="form-label">Valor Unitario</label></div>
                  <div class="col-3">
                    <input type="number" class="form-control"
                           v-model="datoPlanillaDet.valorUni"
                           @input="calcularTotal()" step="0.01" required>
                  </div>
                </div>
              </div>

              <!-- Fecha y Valor Total -->
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-3"><label class="form-label">Fecha de Atención</label></div>
                  <div class="col-3">
                    <input type="date" class="form-control"
                           v-model="datoPlanillaDet.fechaAtencion"
                           :min="getFormattedDateISO(p_fechaDesde)"
                           :max="getFormattedDateISO(p_fechaHasta)">
                  </div>
                  <div class="col-3"><label class="form-label">Valor Total</label></div>
                  <div class="col-3">
                    <input type="text" class="form-control fw-bold text-success"
                           :value="valorTotalFormateado" disabled>
                  </div>
                </div>
              </div>

            </div>
          </form>
          <div class="modal-footer">
            <button v-if="btnCrear" type="button" class="btn btn-light"
                    @click="guardarPlanillaDet()" title="Guardar y cerrar">
              <i class="material-icons" style="font-size:32px;vertical-align:middle;color:blue;cursor:pointer">save</i>
              <span class="d-none d-sm-inline ms-1">Guardar</span>
            </button>
            <button v-if="btnCrear" type="button" class="btn btn-success"
                    @click="guardarYNuevo()" title="Guardar y crear nuevo">
              <i class="material-icons" style="font-size:32px;vertical-align:middle">add_circle</i>
              <span class="ms-1">Guardar y Nuevo</span>
            </button>
            <button v-if="btnEditar" type="button" class="btn btn-light"
                    @click="guardarEditPlanillaDet()" title="Actualizar">
              <i class="material-icons" style="font-size:32px;color:blue;cursor:pointer">update</i>
              <span class="d-none d-sm-inline ms-1">Actualizar</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import api       from "@/services/api";
import Layout    from "@/components/Layout.vue";
import Footer    from "@/components/Footer.vue";
import DataTable from "@/components/DataTable.vue";
import dateFormat from "@/modules/dateFormat.js";
import { validarForm } from '../../modules/validacionesForms.js';
import { openModal, closeModal } from '@/modules/modalHelper.js';

export default {
  props: {
    p_tipoElemento: { type: String,  required: true },
    p_idPlanilla:   { type: Number,  required: false },
    p_idClasElem:   { type: Number,  required: false },
    p_fechaDesde:   { type: Date,    required: true },
    p_fechaHasta:   { type: Date,    required: true },
  },

  components: { Layout, Footer, DataTable },

  data() {
    return {
      planilladets: [],
      datoPlanillaDet: {
        idPlanillaDet: null, idPlanilla: null, idElemento: null,
        elementoCodigo: '', elementoNombre: '', descripcion: '',
        cantidad: 1, valorUni: 0, valorTotal: 0, fechaAtencion: null,
      },
      titulo:                    '',
      btnCrear:                  false,
      btnEditar:                 false,
      searchElemento:            '',
      elementosFiltrados:        [],
      mostrarListaElementos:     false,
      debounceTimer:             null,
      cargandoElementos:         false,
      elementoSeleccionadoCompleto: null,
      mensajeFeedback:           { texto: '', tipo: 'success', detalle: '' },
      feedbackTimeout:           null,
      modalInstance:             null,

      columnas: [
        { field: 'fechaAtencion',  label: 'Fecha' },
        { field: 'elementoCodigo', label: 'Código' },
        { field: 'elementoNombre', label: 'Descripción' },
        { field: 'cantidad',       label: 'Cantidad' },
        { field: 'valorUni',       label: 'Valor Uni' },
        { field: 'valorTotal',     label: 'Total' },
      ],
    };
  },

  computed: {
    valorTotalFormateado() {
      return '$' + this.formatearPrecio(this.datoPlanillaDet.valorTotal);
    },
    labelElemento() {
      return { procedimientos: 'Prestaciones', medicamentos: 'Medicamentos', insumos: 'Insumos' }[this.p_tipoElemento] ?? '';
    },
    placeholderElemento() {
      return { procedimientos: 'de la prestación', medicamentos: 'del medicamento', insumos: 'del insumo' }[this.p_tipoElemento] ?? '';
    },
  },

  mounted() {
    this.cargarDatos()
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
  },

  methods: {
    getFormattedDate(date)    { return dateFormat.getFormattedDate(date); },
    getFormattedDateISO(date) { return dateFormat.getFormattedDateISO(date); },

    formatearPrecio(valor) {
      if (!valor) return '0.00';
      return parseFloat(valor).toFixed(2);
    },

    calcularTotal() {
      const cantidad = parseFloat(this.datoPlanillaDet.cantidad) || 0;
      const valorUni = parseFloat(this.datoPlanillaDet.valorUni) || 0;
      this.datoPlanillaDet.valorTotal = cantidad * valorUni;
    },

    // ── Carga de datos ──────────────────────────────────────────
    cargarDatos() {
      api.get(`/vwplanilladets/idplanilla-clasificacion/${this.p_idPlanilla}/${this.p_idClasElem}`)
        .then(response => { this.planilladets = response.data.reverse() })
        .catch(error   => console.error('Error cargando detalles:', error))
    },

    validarForm() {
      return validarForm(
        this.datoPlanillaDet,
        ['idPlanilla', 'idElemento', 'cantidad', 'valorUni', 'fechaAtencion'],
        ['idPlanilla', '"Elemento"', '"Cantidad"', '"Valor Unitario"', '"Fecha de Atención"']
      );
    },

    // ── Feedback ────────────────────────────────────────────────
    mostrarMensaje(texto, tipo = 'success', duracion = 6000, detalle = '') {
      this.mensajeFeedback = { texto, tipo, detalle };
      if (this.feedbackTimeout) clearTimeout(this.feedbackTimeout);
      if (duracion > 0) {
        this.feedbackTimeout = setTimeout(() => this.ocultarMensajeFeedback(), duracion);
      }
    },
    ocultarMensajeFeedback() {
      this.mensajeFeedback = { texto: '', tipo: 'success', detalle: '' };
      if (this.feedbackTimeout) { clearTimeout(this.feedbackTimeout); this.feedbackTimeout = null; }
    },
    getFeedbackIcon(tipo) {
      return { success: 'check_circle', error: 'error', warning: 'warning', info: 'info' }[tipo] ?? 'info';
    },

    // ── CRUD ────────────────────────────────────────────────────
    async guardarPlanillaDet() {
      this.datoPlanillaDet.idPlanilla = this.p_idPlanilla;
      if (this.validarForm() !== 1) return;
      try {
        await api.post('/planilladets', this.datoPlanillaDet);
        closeModal('ventanaModal');
        this.mostrarMensaje('Registro creado exitosamente!', 'success', 5000);
        this.cargarDatos();
      } catch { this.mostrarMensaje('Error al crear el registro', 'error', 8000, 'Inténtelo nuevamente'); }
    },

    async guardarYNuevo() {
      this.datoPlanillaDet.idPlanilla = this.p_idPlanilla;
      if (this.validarForm() !== 1) return;
      try {
        await api.post('/planilladets', this.datoPlanillaDet);
        this.mostrarMensaje('Registro creado exitosamente!', 'success', 4000);
        this.cargarDatos();
        this.limpiarFormulario();
        this.$nextTick(() => document.getElementById('searchElemento')?.focus());
      } catch { this.mostrarMensaje('Error al guardar', 'error', 8000, 'Verifique los datos e intente nuevamente'); }
    },

    async guardarEditPlanillaDet() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post('/planilladets', this.datoPlanillaDet);
        closeModal('ventanaModal');
        this.mostrarMensaje('Registro actualizado exitosamente!', 'success', 5000);
        this.cargarDatos();
      } catch { this.mostrarMensaje('Error al actualizar', 'error', 8000, 'Inténtelo nuevamente'); }
    },

    async deletePlanillaDet(idPlanillaDet) {
      if (!confirm('¿Estás seguro de eliminar este registro?')) return;
      try {
        await api.delete('/planilladets/' + idPlanillaDet);
        this.cargarDatos();
      } catch { this.mostrarMensaje('No se pudo eliminar el registro', 'error'); }
    },

    // ── Modal ───────────────────────────────────────────────────
    abrirModalCrear() {
      this.datoPlanillaDet = {
        idPlanilla: null, idElemento: null, elementoCodigo: '', elementoNombre: '',
        descripcion: '', cantidad: 1, valorUni: 0, valorTotal: 0, fechaAtencion: null,
      };
      this.searchElemento = '';
      this.elementosFiltrados = [];
      this.elementoSeleccionadoCompleto = null;
      this.titulo    = 'Crear';
      this.btnCrear  = true;
      this.btnEditar = false;
      this.ocultarMensajeFeedback();
      openModal('ventanaModal');
    },

    async abrirModalEditar(idPlanillaDet) {
      if (idPlanillaDet) {
        const { data } = await api.get('/vwplanilladets/' + idPlanillaDet);
        this.datoPlanillaDet = data;
        this.searchElemento  = `${data.elementoCodigo} - ${data.elementoNombre}`;
        if (data.fechaAtencion) {
          this.datoPlanillaDet.fechaAtencion = this.getFormattedDateISO(data.fechaAtencion);
        }
      }
      this.titulo    = 'Editar';
      this.btnCrear  = false;
      this.btnEditar = true;
      this.ocultarMensajeFeedback();
      this.limpiarBackdrops();
      openModal('ventanaModal');
    },

    limpiarFormulario() {
      const idPlanillaActual = this.datoPlanillaDet.idPlanilla;
      this.datoPlanillaDet = {
        idPlanillaDet: null, idPlanilla: idPlanillaActual, idElemento: null,
        elementoCodigo: '', elementoNombre: '', descripcion: '',
        cantidad: 1, valorUni: 0, valorTotal: 0, fechaAtencion: null,
      };
      this.searchElemento = '';
      this.elementosFiltrados = [];
      this.elementoSeleccionadoCompleto = null;
      this.mostrarListaElementos = true;
      if (this.debounceTimer) { clearTimeout(this.debounceTimer); this.debounceTimer = null; }
    },

    limpiarBusqueda() {
      this.searchElemento = '';
      this.elementosFiltrados = [];
      this.datoPlanillaDet.idElemento = null;
      this.datoPlanillaDet.elementoCodigo = '';
      this.datoPlanillaDet.elementoNombre = '';
      this.datoPlanillaDet.valorUni = 0;
      this.elementoSeleccionadoCompleto = null;
      this.mostrarListaElementos = false;
      if (this.debounceTimer) { clearTimeout(this.debounceTimer); this.debounceTimer = null; }
      this.calcularTotal();
    },

    limpiarBackdrops() {
      document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('padding-right');
    },

    // ── LOV elementos ───────────────────────────────────────────
    buscarElementos() {
      if (this.debounceTimer) clearTimeout(this.debounceTimer);
      this.mostrarListaElementos = true;
      this.debounceTimer = setTimeout(() => {
        this.searchElemento.trim().length >= 2
          ? this.fetchElementosFiltrados()
          : this.elementosFiltrados = [];
      }, 400);
    },

    async fetchElementosFiltrados() {
      if (this.searchElemento.trim().length < 2) { this.cargandoElementos = false; return; }
      const idPrestador = {
        procedimientos: window.sessionStorage.getItem('idEmpresa'),
        medicamentos:   10,
        insumos:        11,
      }[this.p_tipoElemento] ?? 0;
      this.cargandoElementos = true;
      try {
        const { data } = await api.get(`/vwtarifapress/search-prestador?idprestador=${idPrestador}&search=${this.searchElemento}`);
        this.elementosFiltrados = data;
      } catch { this.elementosFiltrados = []; }
      finally { this.cargandoElementos = false; }
    },

    seleccionarElemento(elem) {
      this.datoPlanillaDet.idElemento    = elem.idElemento;
      this.datoPlanillaDet.elementoCodigo = elem.elementoCodigo;
      this.datoPlanillaDet.elementoNombre = elem.elementoNombre;
      this.datoPlanillaDet.valorUni       = elem.valor;
      this.elementoSeleccionadoCompleto   = elem;
      this.searchElemento                 = `${elem.elementoCodigo} - ${elem.elementoNombre}`;
      this.mostrarListaElementos          = false;
      this.calcularTotal();
    },

    ocultarListaDelay() {
      setTimeout(() => { this.mostrarListaElementos = false; }, 200);
    },
  },
};
</script>

<style scoped>
.elemento-item {
  padding: 12px 16px;
  transition: all 0.2s ease;
  border-left: 3px solid transparent;
}
.elemento-item:hover {
  background-color: #f8f9fa;
  border-left-color: #0d6efd;
  transform: translateX(2px);
}
.elemento-nombre   { font-size: 14px; color: #333; line-height: 1.4; }
.precio-elemento   { font-size: 18px; font-weight: bold; color: #198754; }
.elemento-seleccionado { animation: fadeIn 0.3s ease; }
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-5px); }
  to   { opacity: 1; transform: translateY(0); }
}
.feedback-container { min-height: 64px; }
.feedback-slide-enter-active,
.feedback-slide-leave-active { transition: all 0.4s ease; }
.feedback-slide-enter-from   { opacity: 0; transform: translateY(-20px); }
.feedback-slide-leave-to     { opacity: 0; transform: translateY(-10px); height: 0; margin: 0; padding: 0; }
.alert { border: none; border-radius: 8px; }
</style>